import React, { PropsWithChildren } from 'react';
import ButtonBase from './ButtonBase';

interface ButtonLinkProps {
  onClick: CallableFunction;
  disabled?: boolean;
  rounded?: boolean;
  className?: string;
  outline?: boolean;
}

const ButtonLink = ({
  children,
  onClick = () => {},
  disabled = false,
  rounded = false,
  className,
  outline = false

}: PropsWithChildren<ButtonLinkProps>) => {

  const handleClick = () => onClick();

  return (
    <ButtonBase 
      onClick={handleClick}
      disabled={disabled}
      rounded={rounded}
      className={`
        ${className} text-sky-500
        ${outline ? 'ring-sky-500 hover:ring-sky-400 bg-none hover:bg-sky-50' : 'ring-transparent bg-sky-50 hover:bg-sky-100'}
    `}>
      {children}
    </ButtonBase>
  )
}

export default ButtonLink;